module.exports = require('./helpers/bundle-url').getBundleURL('1OwBs') + "demo-no-fx.e2cebf6f.svg" + "?" + Date.now();